import { render, staticRenderFns } from "./HotsiteSlot.vue?vue&type=template&id=53e5d89b"
import script from "./HotsiteSlot.vue?vue&type=script&lang=js"
export * from "./HotsiteSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports